/**
 * Display helpers for the Audit Log page (OL-156). Kept free of '@/utils' so
 * they stay unit-testable.
 */

/** Badge colour per action: red for removals and failures, amber for data leaving. */
export const actionBadge = (action) => {
  if (['delete', 'bulk_delete', 'login_failed', 'lockout', 'role_revoked', 'permission_revoked'].includes(action)) {
    return 'badge-danger';
  }
  if (['export', 'export_requested', 'download'].includes(action)) return 'badge-warning';
  if (['create', 'restore', 'role_granted', 'permission_granted'].includes(action)) return 'badge-success';
  if (['login', 'logout'].includes(action)) return 'badge-info';
  return 'badge-primary';
};

const HIDDEN_KEYS = new Set(['id', 'tenant_id', 'created_by', 'updated_at']);

const show = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  if (Array.isArray(value)) return value.map(show).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

/** The entry's stored details as label/value pairs, internal ids left out. */
export const detailRows = (details) =>
  Object.entries(details && typeof details === 'object' ? details : {})
    .filter(([key]) => !HIDDEN_KEYS.has(key) && !key.endsWith('_id'))
    .map(([key, value]) => ({
      label: key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      value: show(value),
    }));

/** Query parameters for the API, without empty filters. */
export const toParams = (filters, page) => {
  const params = Object.fromEntries(Object.entries(filters ?? {}).filter(([, v]) => v !== '' && v !== null && v !== undefined));
  return page ? { ...params, page } : params;
};
